export const TEXTAREA_FIELD = {
  'foodandbeveragepreparationserving.preparationserving.preparationinstructions.value':
    {
      maxLength: 2000,
    },
  'packagingmarking.packagingmarking.consumerwarninginformation.consumerwarningdescription.value':
    {
      maxLength: 3000,
    },
  'foodandbeverageingredient.ingredientstatement.value': {
    maxLength: 2000,
  },
};
